import React, { useEffect, useState } from 'react'
import TablaPosiblesArribosView from '../components/TablaPosiblesArribosView'
import { actualizarPosiblesArribos } from '../actions/TablaPosiblesArribosActions'
import UltimaActualizacionData from '../../../../Utils/containers/UltimaActualizacionDatos'
import { connect } from 'react-redux'

function TablaPosiblesArribos (props) {
  const { roles, actualizarPosiblesArribos, filtroInicial = null, cerealFiltro = null, fechaD, fechaH, actualizacion } = props
  const [ultimaActualizacion, setUltimaActualizacion] = useState(actualizacion)

  useEffect(() => {
    actualizarPosiblesArribos(fechaD, fechaH, cerealFiltro, filtroInicial)
  }, [actualizarPosiblesArribos, roles, filtroInicial, cerealFiltro, fechaD, fechaH])

  const actualizar = () => {
    const actualiza = true
    actualizarPosiblesArribos(fechaD, fechaH, cerealFiltro, filtroInicial, actualiza)
  }

  return (
    <>
      {ultimaActualizacion &&
        <UltimaActualizacionData
          actualizar={actualizar}
          ultimaActualizacion={ultimaActualizacion}
          setUltimaActualizacion={setUltimaActualizacion}
          // iconColor='white'
        />}
      <TablaPosiblesArribosView />
    </>
  )
}

const mapActionsToProps = {
  actualizarPosiblesArribos
}

const mapStateToProps = (state) => ({
  actualizacion: state.dashboard.actualizacionEstadoArribo
})

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(TablaPosiblesArribos)
